import Vue from "vue";
import Vuex from "vuex";

let cities = [
  "Acton",
  "Alberton",
  "Alder",
  "Alpine",
  "Alzada",
  "Amsterdam",
  "Anaconda",
  "Angela",
  "Antelope",
  "Apgar",
  "Arlee",
  "Armington",
  "Ashland",
  "Augusta",
  "Avon",
  "Babb",
  "Bainville",
  "Baker",
  "Ballantine",
  "Basin",
  "Bearcreek",
  "Beehive",
  "Belfry",
  "Belgrade",
  "Belt",
  "Benchland",
  "Biddle",
  "Big Arm",
  "Big Sandy",
  "Big Sky",
  "Big Timber",
  "Bigfork",
  "Bighorn",
  "Billings",
  "Birney",
  "Blackfoot",
  "Bloomfield",
  "Bonner",
  "Boulder",
  "Box Elder",
  "Boyd",
  "Boyes",
  "Bozeman",
  "Brady",
  "Bridger",
  "Broadus",
  "Broadview",
  "Brockton",
  "Brockway",
  "Browning",
  "Brusett",
  "Buffalo",
  "Busby",
  "Butte",
  "Bynum",
  "Cameron",
  "Canyon Creek",
  "Capitol",
  "Cardwell",
  "Carter",
  "Cascade",
  "Cat Creek",
  "Charlo",
  "Chester",
  "Chinook",
  "Choteau",
  "Circle",
  "Clancy",
  "Clinton",
  "Clyde Park",
  "Coffee Creek",
  "Cohagen",
  "Colstrip",
  "Columbia Falls",
  "Columbus",
  "Condon",
  "Conner",
  "Conrad",
  "Cooke City",
  "Coram",
  "Corvallis",
  "Corwin Springs",
  "Craig",
  "Crane",
  "Creston",
  "Crow Agency",
  "Culbertson",
  "Cushman",
  "Custer",
  "Cut Bank",
  "Dagmar",
  "Darby",
  "Dayton",
  "De Borgia",
  "Decker",
  "Deer Lodge",
  "Dell",
  "Denton",
  "Dillon",
  "Divide",
  "Dixon",
  "Dodson",
  "Drummond",
  "Dupuyer",
  "Dutton",
  "East Glacier Park",
  "East Helena",
  "Edgar",
  "Ekalaka",
  "Elliston",
  "Elmo",
  "Emigrant",
  "Enid",
  "Ennis",
  "Essex",
  "Ethridge",
  "Eureka",
  "Fairfield",
  "Fairview",
  "Fallon",
  "Ferdig",
  "Fishtail",
  "Flaxville",
  "Florence",
  "Floweree",
  "Forest Grove",
  "Forsyth",
  "Fort Benton",
  "Fort Harrison",
  "Fort Peck",
  "Fort Shaw",
  "Fort Smith",
  "Fortine",
  "Four Buttes",
  "Frazer",
  "Frenchtown",
  "Froid",
  "Fromberg",
  "Galata",
  "Galen",
  "Gallatin Gateway",
  "Gardiner",
  "Garneill",
  "Garrison",
  "Garryowen",
  "Georgetown",
  "Geraldine",
  "Geyser",
  "Gildford",
  "Glasgow",
  "Glen",
  "Glendive",
  "Glentana",
  "Gold Creek",
  "Grant",
  "Grantsdale",
  "Grass Range",
  "Great Falls",
  "Greenough",
  "Greycliff",
  "Hall",
  "Hamilton",
  "Hammond",
  "Hardin",
  "Harlem",
  "Harlowton",
  "Harrison",
  "Hathaway",
  "Haugan",
  "Havre",
  "Hays",
  "Heart Butte",
  "Heath",
  "Helena",
  "Helmville",
  "Heron",
  "Highwood",
  "Hilger",
  "Hingham",
  "Hinsdale",
  "Hobson",
  "Hogeland",
  "Homestead",
  "Hot Springs",
  "Hungry Horse",
  "Huntley",
  "Huson",
  "Hysham",
  "Ingomar",
  "Inverness",
  "Ismay",
  "Jackson",
  "Jardine",
  "Jefferson City",
  "Joliet",
  "Joplin",
  "Jordan",
  "Judith Gap",
  "Kalispell",
  "Kevin",
  "Kila",
  "Kinsey",
  "Klein",
  "Kremlin",
  "Lake Mc Donald",
  "Lakeside",
  "Lambert",
  "Lame Deer",
  "Larslan",
  "Laurel",
  "Lavina",
  "Ledger",
  "Lennep",
  "Lewistown",
  "Libby",
  "Lima",
  "Lincoln",
  "Lindsay",
  "Livingston",
  "Lloyd",
  "Lockwood",
  "Lodge Grass",
  "Lolo",
  "Loma",
  "Lonepine",
  "Loring",
  "Lothair",
  "Lustre",
  "Luther",
  "Malmstrom A F B",
  "Malta",
  "Manhattan",
  "Marion",
  "Martin City",
  "Martinsdale",
  "Marysville",
  "Mc Allister",
  "Mc Leod",
  "McCabe",
  "Medicine Lake",
  "Melrose",
  "Melstone",
  "Melville",
  "Mildred",
  "Miles City",
  "Mill Iron",
  "Milltown",
  "Miner",
  "Missoula",
  "Moccasin",
  "Moiese",
  "Molt",
  "Monarch",
  "Montana City",
  "Montana Power Co",
  "Montana State Univ Bozeman",
  "Moore",
  "Mosby",
  "Msla",
  "Musselshell",
  "Nashua",
  "Neihart",
  "Niarada",
  "Norris",
  "Noxon",
  "Nye",
  "Oilmont",
  "Olive",
  "Olney",
  "Opheim",
  "Opportunity",
  "Otter",
  "Outlook",
  "Ovando",
  "Pablo",
  "Paradise",
  "Park City",
  "Peerless",
  "Pendroy",
  "Philipsburg",
  "Pinesdale",
  "Plains",
  "Plentywood",
  "Plevna",
  "Polaris",
  "Polebridge",
  "Polson",
  "Pompeys Pillar",
  "Pony",
  "Poplar",
  "Potomac",
  "Powderville",
  "Power",
  "Pray",
  "Proctor",
  "Pryor",
  "Radersburg",
  "Ramsay",
  "Rapelje",
  "Ravalli",
  "Raymond",
  "Raynesford",
  "Red Lodge",
  "Redstone",
  "Reed Point",
  "Reserve",
  "Rexford",
  "Richey",
  "Richland",
  "Ringling",
  "Roberts",
  "Rocker",
  "Rocky Boy",
  "Rollins",
  "Ronan",
  "Roscoe",
  "Rosebud",
  "Roundup",
  "Roy",
  "Rudyard",
  "Ryegate",
  "Saco",
  "Saint Ignatius",
  "Saint Marie",
  "Saint Mary",
  "Saint Regis",
  "Saint Xavier",
  "Saltese",
  "Sand Coulee",
  "Sand Springs",
  "Sanders",
  "Santa Rita",
  "Savage",
  "Scobey",
  "Seeley Lake",
  "Shawmut",
  "Shelby",
  "Shepherd",
  "Sheridan",
  "Shonkin",
  "Sidney",
  "Silesia",
  "Silver Gate",
  "Silver Star",
  "Simms",
  "Snider",
  "Somers",
  "Sonnette",
  "Springdale",
  "Square Butte",
  "Stanford",
  "Stevensville",
  "Stockett",
  "Stryker",
  "Sula",
  "Sumatra",
  "Sun River",
  "Sunburst",
  "Superior",
  "Swan Lake",
  "Sweet Grass",
  "Tampico",
  "Teigen",
  "Terry",
  "Thompson Falls",
  "Three Forks",
  "Toston",
  "Townsend",
  "Tracy",
  "Trego",
  "Trident",
  "Trout Creek",
  "Troy",
  "Turah",
  "Turner",
  "Twin Bridges",
  "Two Dot",
  "Ulm",
  "Valier",
  "Vandalia",
  "Vaughn",
  "Victor",
  "Vida",
  "Virginia City",
  "Volborg",
  "Wagner",
  "Walkerville",
  "Warm Springs",
  "Washoe",
  "West Glacier",
  "West Yellowstone",
  "Westby",
  "White Sulphur Springs",
  "Whitefish",
  "Whitehall",
  "Whitetail",
  "Whitewater",
  "Whitlash",
  "Wibaux",
  "Willard",
  "Willow Creek",
  "Wilsall",
  "Windham",
  "Winifred",
  "Winnett",
  "Winston",
  "Wisdom",
  "Wise River",
  "Wolf Creek",
  "Wolf Point",
  "Worden",
  "Wyola",
  "Yaak",
  "Zortman",
  "Zurich"
];

let counties = [
  "All Counties",
  "Beaverhead",
  "Big Horn",
  "Blaine",
  "Broadwater",
  "Carbon",
  "Carter",
  "Cascade",
  "Chouteau",
  "Custer",
  "Daniels",
  "Dawson",
  "Deer Lodge",
  "Fallon",
  "Fergus",
  "Flathead",
  "Gallatin",
  "Garfield",
  "Glacier",
  "Golden Valley",
  "Granite",
  "Hill",
  "Jefferson",
  "Judith Basin",
  "Lake",
  "Lewis And Clark",
  "Liberty",
  "Lincoln",
  "Madison",
  "McCone",
  "Meagher",
  "Mineral",
  "Missoula",
  "Musselshell",
  "Park",
  "Petroleum",
  "Phillips",
  "Pondera",
  "Powder River",
  "Powell",
  "Prairie",
  "Ravalli",
  "Richland",
  "Roosevelt",
  "Rosebud",
  "Sanders",
  "Sheridan",
  "Silver Bow",
  "Stillwater",
  "Sweet Grass",
  "Teton",
  "Toole",
  "Treasure",
  "Valley",
  "Wheatland",
  "Wibaux",
  "Yellowstone"
];

let regions = [
  "Central",
  "Southeastern",
  "Southwestern",
  "Western",
  "Northwestern"
];

Vue.use(Vuex);
let version = 25;
let agencyData = JSON.parse(localStorage.getItem("agencyData"));
let storedVersion = JSON.parse(localStorage.getItem("version"));

if (version != storedVersion) {
  agencyData = "";
}

let agencyDataBlank = {
  region: {
    data: "",
    label: "Region",
    hint: "",
    type: "action",
    items: regions,
    to: "providers",
    rules: ["required"],
    cols: 2
  },
  agency_name: {
    data: "",
    label: "Agency Name",
    hint: "",
    type: "text",
    rules: ["required"],
    update_rules: ["required"],
    cols: 5
  },
  other_names: {
    data: [],
    label: "Other Names",
    hint:
      "Other names this service may be known by (former names, acronyms, ect.)",
    type: "array",
    rules: [],
    cols: 5
  },
  agency_description: {
    data: "",
    label: "Agency Description",
    hint:
      "Please provide a brief description of your agency and what your provide for services",
    type: "textarea",
    rules: ["required"],
    cols: 12
  },
  eligibility_requirments: {
    data: "",
    label: "More Eligibility Details",
    hint: "",
    type: "textarea",
    rules: [],
    cols: 12
  },
  eligibility_list: {
    data: [],
    label: "Eligibility",
    hint: "",
    type: "eligibility",
    items: ["Adult", "Teen", "Child", "Family", "Female", "Male"],
    rules: [],
    cols: 12
  },
  program_fees: {
    data: [],
    label: "Program Fees",
    hint: "",
    type: "dropdown",
    items: ["Free", "Sliding Scale", "Unknown"],
    rules: [],
    cols: 12
  },
  application_process: {
    data: "",
    label: "Application Process (Type N/A if none)",
    hint: "Please provide a brief description of your application process",
    type: "textarea",
    rules: ["required"],
    cols: 12
  },
  volunteer_opportunites: {
    data: false,
    label: "Volunteer opportunities are available?",
    hint: "",
    type: "boolean",
    rules: [],
    cols: 6
  },
  counties_served: {
    data: [],
    label: "Counties Served",
    hint: "",
    items: counties,
    type: "multichoice",
    rules: ["array_required"],
    cols: 6
  },
  agency_primary_address: {
    data: "",
    label: "Agency Primary Address",
    hint: "Physical Address of Agency",
    type: "text",
    rules: ["required"],
    cols: 6
  },
  city: {
    data: "",
    label: "City",
    hint: "",
    type: "text",
    // items: cities,
    rules: ["required"],
    cols: 3
  },
  zip: {
    data: "",
    label: "Zip",
    hint: "",
    type: "text",
    rules: ["required"],
    cols: 3
  },
  address_confidential: {
    data: false,
    label: "Is this address confidential?",
    hint: "",
    type: "boolean",
    rules: [],
    cols: 6
  },
  disabilities_accessible: {
    data: false,
    label: "Is this location disabilities accessible?",
    hint: "",
    type: "boolean",
    rules: [],
    cols: 6
  },
  mailing_address_is_same: {
    data: false,
    label: "Mailing address is the same as primary address?",
    hint: "",
    type: "boolean",
    rules: [],
    cols: 12
  },
  mailing_address: {
    data: "",
    label: "Mailing address",
    hint: "",
    type: "text",
    rules: ["required"],
    cols: 6,
    dupifcheck: {
      checkbox: "mailing_address_is_same",
      field_to_dup: "agency_primary_address"
    }
  },
  mailing_city: {
    data: "",
    label: "Mailing city",
    hint: "",
    type: "text",
    // items: cities,
    rules: [],
    cols: 3,
    dupifcheck: { checkbox: "mailing_address_is_same", field_to_dup: "city" }
  },
  mailing_zip: {
    data: "",
    label: "Mailing Zip",
    hint: "",
    type: "text",
    rules: [],
    cols: 3,
    dupifcheck: { checkbox: "mailing_address_is_same", field_to_dup: "zip" }
  },
  office_hours: {
    data: [],
    label: "Office Hours",
    hint: "",
    type: "office_hours",
    rules: ["array_required"],
    cols: 12
  },
  agency_phone: {
    data: "",
    label: "Phone Number",
    hint: "For clients to inquire about services",
    type: "phone",
    rules: ["required"],
    cols: 5
  },
  agency_phone_ext: {
    data: "",
    label: "Ext",
    hint: "",
    type: "text",
    rules: [],
    cols: 1
  },
  agency_fax: {
    data: "",
    label: "Fax",
    hint: "",
    type: "phone",
    rules: [],
    cols: 6
  },
  main_email: {
    data: "",
    label: "Main Email",
    hint: "",
    type: "text",
    rules: ["email"],
    cols: 6
  },
  agency_website: {
    data: "",
    label: "Website",
    hint: "",
    type: "text",
    rules: [],
    cols: 6
  },
  main_contact_person: {
    data: "",
    label: "Main Contact Person",
    hint: "",
    type: "text",
    rules: ["required"],
    update_rules: ["required"],
    cols: 3
  },
  main_contact_title: {
    data: "",
    label: "Title",
    hint: "",
    type: "text",
    rules: ["required"],
    update_rules: ["required"],
    cols: 2
  },
  main_contact_phone: {
    data: "",
    label: "Phone",
    hint: "",
    type: "phone",
    rules: ["required"],
    update_rules: ["required"],
    cols: 3
  },
  main_contact_phone_ext: {
    data: "",
    label: "Ext",
    hint: "",
    type: "text",
    rules: [],
    cols: 1
  },
  main_contact_email: {
    data: "",
    label: "Email",
    hint: "",
    type: "text",
    rules: ["required", "email"],
    update_rules: ["required", "email"],
    cols: 3
  },
  main_contact_private: {
    data: false,
    label: "Main contact is private.  Do not disclose to outside parties?",
    hint: "",
    type: "boolean",
    rules: [],
    cols: 12
  },
  agency_director: {
    data: "",
    label: "Agency Director or Senior Administrator",
    hint: "",
    type: "text",
    rules: ["required"],
    cols: 4
  },
  agency_director_phone: {
    data: "",
    label: "Phone",
    hint: "",
    type: "phone",
    rules: ["required"],
    update_rules: [],
    cols: 3
  },
  agency_director_phone_ext: {
    data: "",
    label: "Ext",
    hint: "",
    type: "text",
    rules: [],
    cols: 1
  },
  agency_director_email: {
    data: "",
    label: "Email",
    hint: "",
    type: "text",
    rules: ["required", "email"],
    update_rules: ["email"],
    cols: 4
  },
  agency_director_private: {
    data: false,
    label:
      "Senior Administrator is private.  Do not disclose to outside parties?",
    hint: "",
    type: "boolean",
    rules: [],
    cols: 12
  },
  comments: {
    data: "",
    label: "Comments",
    hint: "",
    type: "textarea",
    rules: [],
    cols: 12
  }
};

if (!agencyData) {
  agencyData = agencyDataBlank;
}

let programData = {
  region: {
    data: "",
    label: "Region",
    hint: "",
    type: "action",
    items: regions,
    to: "providers",
    rules: ["required"],
    cols: 3
  },
  agency_name: {
    data: "",
    label: "Agency Name",
    hint: "",
    type: "text",
    rules: ["required"],
    update_rules: ["required"],
    cols: 3
  },
  program_name: {
    data: "",
    label: "Program Name",
    hint: "",
    type: "text",
    rules: ["required"],
    update_rules: ["required"],
    cols: 3
  },
  other_names: {
    data: [],
    label: "Other Names",
    hint:
      "Other names this service may be known by (former names, acronyms, ect.)",
    type: "array",
    rules: [],
    cols: 3
  },
  program_description: {
    data: "",
    label: "Program Description",
    hint:
      "Please provide a brief description of your program and what your provide for services",
    type: "textarea",
    rules: ["required"],
    cols: 12
  },
  eligibility_requirments: {
    data: "",
    label: "More Eligibility Details",
    hint: "",
    type: "textarea",
    rules: [],
    cols: 12
  },
  eligibility_list: {
    data: [],
    label: "Eligibility",
    hint: "",
    type: "eligibility",
    items: ["Adult", "Teen", "Child", "Family", "Female", "Male"],
    rules: [],
    cols: 12
  },
  program_fees: {
    data: [],
    label: "Program Fees",
    hint: "",
    type: "dropdown",
    items: ["Free", "Sliding Scale", "Unknown"],
    rules: [],
    cols: 12
  },
  application_process: {
    data: "",
    label: "Application Process (Type N/A if none)",
    hint: "Please provide a brief description of your application process",
    type: "textarea",
    rules: ["required"],
    cols: 12
  },
  volunteer_opportunites: {
    data: false,
    label: "Volunteer opportunities are available?",
    hint: "",
    type: "boolean",
    rules: [],
    cols: 6
  },
  counties_served: {
    data: [],
    label: "Counties Served",
    hint: "",
    items: counties,
    type: "multichoice",
    rules: ["array_required"],
    cols: 6
  },
  program_primary_address: {
    data: "",
    label: "Program Primary Address",
    hint: "Physical Address of Program",
    type: "text",
    rules: ["required"],
    cols: 6
  },
  city: {
    data: "",
    label: "City",
    hint: "",
    type: "dropdown",
    items: cities,
    rules: ["required"],
    cols: 3
  },
  zip: {
    data: "",
    label: "Zip",
    hint: "",
    type: "text",
    rules: ["required"],
    cols: 3
  },
  address_confidential: {
    data: false,
    label: "Is this address confidential?",
    hint: "",
    type: "boolean",
    rules: [],
    cols: 6
  },
  disabilities_accessible: {
    data: false,
    label: "Is this location disabilities accessible?",
    hint: "",
    type: "boolean",
    rules: [],
    cols: 6
  },
  mailing_address_is_same: {
    data: false,
    label: "Mailing address is the same as primary address?",
    hint: "",
    type: "boolean",
    rules: [],
    cols: 12
  },
  mailing_address: {
    data: "",
    label: "Mailing address",
    hint: "",
    type: "text",
    rules: ["required"],
    cols: 6,
    dupifcheck: {
      checkbox: "mailing_address_is_same",
      field_to_dup: "program_primary_address"
    }
  },
  mailing_city: {
    data: "",
    label: "Mailing city",
    hint: "",
    type: "dropdown",
    items: cities,
    rules: [],
    cols: 3,
    dupifcheck: { checkbox: "mailing_address_is_same", field_to_dup: "city" }
  },
  mailing_zip: {
    data: "",
    label: "Mailing Zip",
    hint: "",
    type: "text",
    rules: [],
    cols: 3,
    dupifcheck: { checkbox: "mailing_address_is_same", field_to_dup: "zip" }
  },
  office_hours: {
    data: [],
    label: "Office Hours",
    hint: "",
    type: "office_hours",
    rules: ["array_required"],
    cols: 12
  },
  program_phone: {
    data: "",
    label: "Phone Number",
    hint: "For clients to inquire about services",
    type: "phone",
    rules: ["required"],
    cols: 5
  },
  program_phone_ext: {
    data: "",
    label: "Ext",
    hint: "",
    type: "text",
    rules: [],
    cols: 1
  },
  program_fax: {
    data: "",
    label: "Fax",
    hint: "",
    type: "phone",
    rules: [],
    cols: 6
  },
  main_email: {
    data: "",
    label: "Main Email",
    hint: "",
    type: "text",
    rules: ["email"],
    cols: 6
  },
  program_website: {
    data: "",
    label: "Website",
    hint: "",
    type: "text",
    rules: [],
    cols: 6
  },
  main_contact_person: {
    data: "",
    label: "Main Contact Person",
    hint: "",
    type: "text",
    rules: ["required"],
    update_rules: ["required"],
    cols: 3
  },
  main_contact_title: {
    data: "",
    label: "Title",
    hint: "",
    type: "text",
    rules: ["required"],
    update_rules: ["required"],
    cols: 2
  },
  main_contact_phone: {
    data: "",
    label: "Phone",
    hint: "",
    type: "phone",
    rules: ["required"],
    update_rules: ["required"],
    cols: 3
  },
  main_contact_phone_ext: {
    data: "",
    label: "Ext",
    hint: "",
    type: "text",
    rules: [],
    cols: 1
  },
  main_contact_email: {
    data: "",
    label: "Email",
    hint: "",
    type: "text",
    rules: ["required", "email"],
    update_rules: ["required", "email"],
    cols: 3
  },
  main_contact_private: {
    data: false,
    label: "Main contact is private.  Do not disclose to outside parties?",
    hint: "",
    type: "boolean",
    rules: [],
    cols: 12
  },
  program_director: {
    data: "",
    label: "Program Director",
    hint: "",
    type: "text",
    rules: ["required"],
    cols: 4
  },
  program_director_phone: {
    data: "",
    label: "Phone",
    hint: "",
    type: "phone",
    rules: ["required"],
    update_rules: [],
    cols: 3
  },
  program_director_phone_ext: {
    data: "",
    label: "Ext",
    hint: "",
    type: "text",
    rules: [],
    cols: 1
  },
  program_director_email: {
    data: "",
    label: "Email",
    hint: "",
    type: "text",
    rules: ["required", "email"],
    update_rules: ["email"],
    cols: 4
  },
  program_director_private: {
    data: false,
    label: "Program Director is private.  Do not disclose to outside parties?",
    hint: "",
    type: "boolean",
    rules: [],
    cols: 12
  },
  comments: {
    data: "",
    label: "Comments",
    hint: "",
    type: "textarea",
    rules: [],
    cols: 12
  }
};

export default new Vuex.Store({
  state: {
    agencyData: agencyData,
    agencyDataBlank: agencyDataBlank,
    programData: programData,
    programDataBlank: JSON.parse(JSON.stringify(programData)),
    update: false
  },
  mutations: {
    set_update: (state, data) => {
      state.update = data;
    },
    set_agencyData: (state, data) => {
      state.agencyData = data;
      state.programData.region.data = data.region.data;
      localStorage.setItem("agencyData", JSON.stringify(data));
      localStorage.setItem("version", version);
    },
    set_programData: (state, data) => {
      state.agencyData.region.data = data.region.data;
      state.programData = data;
    }
  },
  actions: {}
});
